import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Loader } from "@/components/public/Bits";
import { sanitizeHtml } from "@/lib/sanitize";

export default function About() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/public/settings").then((r) => setContent(r.data.about?.content || "")).catch(() => setContent(""));
  }, []);

  return (
    <div>
      <PageHeader eyebrow="The Federation" title="About UKF" kanji="道" />
      <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 md:py-20 lg:px-8">
        {content === null ? (
          <Loader />
        ) : content.trim() ? (
          <article
            className="rte-content"
            data-testid="about-content"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
          />
        ) : (
          <EmptyState
            icon={Info}
            kanji="道"
            title="Information coming soon"
            message="Official information about the Union of Karate Federations will be published here."
            testid="about-empty"
          />
        )}
      </div>
    </div>
  );
}
